import { Card } from "@/components/ui/card";

const SparkCertificate = () => {
  return (
    <div className="mt-12 animate-fade-in">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          {/* Cream frame outer layer */}
          <div
        className="cha-card-cream p-7 overflow-hidden isolate"
      >
        <Card className="overflow-hidden hover:shadow-medium transition-all border-0">
          <div className="p-8">
            <h4 className="font-header text-lg font-bold text-[#2C003E] mb-6 text-center">
              SPARK Certificate
            </h4>
            <div className="flex justify-center">
              <img 
                src="/spark_certificate.png" 
                alt="SPARK 5-Star Quality Rating Certificate for The Children's Hour Academy"
                className="w-full max-w-3xl h-auto rounded-lg shadow-md"
                loading="lazy"
              />
            </div>
          </div>
        </Card>
      </div>
        </div>
      </div>
    </div>
  );
};

export default SparkCertificate;
